// extracted by mini-css-extract-plugin
module.exports = {"exhibition":"ApplyReturnFeeModal_style_exhibition__2jtqs"};